export class PricingPage {

    constructor() {
        this._initPlansSwitcher();
    }

    _initPlansSwitcher() {
        var $mode = 'annually';

        var $plansMonthItem = $('.pricing__switch-item--monthly');
        var $plansYearItem = $('.pricing__switch-item--annually');
        var $plansToggler = $('.pricing__switch-toggle');
        var $plansTogglerCircle = $('.pricing__switch-toggle-circle');

        var $monthPrices = $('.pricing__plan-price-value--monthly');
        var $yearPrices = $('.pricing__plan-price-value--annually');

        const togglePrices = function() {
            if ($mode == 'monthly') {
                $plansMonthItem.removeClass('selected');
                $plansYearItem.addClass('selected');
                $plansTogglerCircle.addClass('annually').removeClass('monthly');
                $monthPrices.removeClass('selected').addClass('hidden');
                $yearPrices.addClass('selected').removeClass('hidden');
                $mode = 'annually';
            } else if ($mode == 'annually') {
                $plansMonthItem.addClass('selected');
                $plansYearItem.removeClass('selected');
                $plansTogglerCircle.addClass('monthly').removeClass('annually');
                $yearPrices.removeClass('selected').addClass('hidden');
                $monthPrices.addClass('selected').removeClass('hidden');
                $mode = 'monthly';
            }
        }

        $plansToggler.click(function () {
            togglePrices();
        });
    }

}

new PricingPage();
